import React, { ComponentType, Suspense } from 'react';

import Loader from "../Layout/Loader";

export const Loadable = <P extends object>(
   Component: ComponentType<P>
): React.FC<P> => {
   return function LoadableComponent(props: P) {
      return (
         <Suspense fallback={<Loader />}>
            <Component {...props} />
         </Suspense>
      );
   };
};
